import React from 'react'
import images from '../../../themes/appImage'
import appconstant from '../../../themes/appconstant';


let moodDescriptionOptions = {
  bestPossible: "Best Possible",
  great: "Great",
  "veryGood": "Very Good",
  "good": "Good",
  "prettyGood": "Pretty Good",
  "okay": "Okay",
  "beenBetter": "Been Better",
  bad: "Bad",
  "veryBad": "Very Bad",
  "worstPossible": "Worst Possible",
  positive: "Positive",
  veryPositive: "Very Positive",
  neutral: "Neutral",
  negative: "Negative",
  veryNegative: "Very Negative"
};

const EmojiCard = ({ moodImage, moodDescription, percentageChange }) => {
  return (
    <div className='border w-[223px] border-brightPink image-gradient rounded-[20px] flex flex-col justify-between p-4 mb-2 mr-3'>
      <div className='flex flex-col justify-center items-center pt-[30px]'>
        <img src={moodImage} alt={moodDescription} className='w-[109px] h-[109px] mb-2 object-contain' />
        <div className='text-xs text-gray60 font-normal'>{appconstant.averageMood}</div>
        <div className='text-xl text-center text-dark font-semibold'>{moodDescriptionOptions[moodDescription]}</div>
      </div>
      <div className='flex justify-between items-center pt-4'>
        <div className='text-xs text-dark font-normal'>{appconstant.currentvsprevious}</div>
        <div className="flex items-center justify-center">
          <div className='border border-brightPink bg-bgpink rounded-[14px] flex justify-between items-center p-[7px]'>
            <div className='text-xs text-dark font-normal'>{percentageChange}%</div>
            <div ><img src={images.arrowUp} alt="arrowup" /></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmojiCard;
